import React from "react"
import FontAwesome from "react-fontawesome"
import { Link } from "react-router"

const ItemSetting = ({to, title, desc, iconName, size}) =>
<div className="itemSetting">
  <Link to={ to }>
    <FontAwesome name={ iconName } size={ size ? size : null }/> &nbsp;
    <strong>{ title }</strong>
    <p>{ desc }</p>
  </Link>
</div>

export default ItemSetting



// WEBPACK FOOTER //
// ./src/components/Settings/ItemSetting.js